(() => {
  if (window.FF_CARTLIFT_INTEGRATION_INITIALIZED) return;
  window.FF_CARTLIFT_INTEGRATION_INITIALIZED = true;

  const WIDGET_SELECTOR = '.wp-small-order-widget-root';
  const PAGE_SLOT = '[data-ff-cartlift-slot="page"]';
  const DRAWER_SLOT = '[data-ff-cartlift-slot="drawer"]';

  const moveWidget = (widget) => {
    if (!(widget instanceof Element) || widget.closest('[data-ff-cartlift-slot]')) return;

    const pageSection = document.querySelector('.shopify-section--main-cart');
    const pageSlot = pageSection?.querySelector(PAGE_SLOT);
    if (pageSection && pageSlot && pageSection.contains(widget)) {
      pageSlot.appendChild(widget);
      return;
    }

    const drawer = document.querySelector('#cart-drawer');
    const drawerSlot = drawer?.querySelector(DRAWER_SLOT);
    if (drawer && drawerSlot && drawer.contains(widget)) {
      drawerSlot.appendChild(widget);
      return;
    }

    // CartLift currently injects the full-cart widget immediately before the cart form.
    // When the page section cannot be inferred from the widget's original parent, prefer
    // the cart page slot on cart pages and the drawer slot elsewhere.
    if (pageSlot) {
      pageSlot.appendChild(widget);
    } else if (drawerSlot) {
      drawerSlot.appendChild(widget);
    }
  };

  const relocate = () => {
    document.querySelectorAll(WIDGET_SELECTOR).forEach(moveWidget);
  };

  let scheduled = false;
  const schedule = () => {
    if (scheduled) return;
    scheduled = true;
    window.requestAnimationFrame(() => {
      scheduled = false;
      relocate();
    });
  };

  document.addEventListener('DOMContentLoaded', schedule);
  document.addEventListener('cart:change', schedule);
  document.addEventListener('cart:updated', schedule);
  document.addEventListener('cart:refresh', schedule);

  const observer = new MutationObserver(schedule);
  observer.observe(document.documentElement, { childList: true, subtree: true });
  schedule();
})();
